/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  Button,
  Checkbox,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  TextField,
  Chip,
} from "@mui/material";
import {
  Add,
  Cancel,
  Clear,
  CreditCard,
  Done,
  Edit,
  LocalAtm,
  NearMe,
  Pause,
  Check,
  Commit,
  PlayArrow,
  Visibility,
} from "@mui/icons-material";
import { validateLatePenalty } from "../components/modules/latePenaltyConfig";
import {
  activateMeterBilling,
  deleteDraftMeterBilling,
  downloadMeterBillings,
  exportMeterBillings,
  getMeterBilling,
  getMetersByFacilityNotInActiveBilling,
  getMetersByMeterBilling,
  getTotalMeterBillings,
  removeMeterFromBilling,
  resendLastMeterBillingInvoice,
  resendLastMeterBillingReceipt,
  resendMeterBillingStatement,
  saveMeterBillingNote,
  saveMeterBillingPayment,
  saveNewMeterBilling,
  suspendMeterBilling,
  addMeterToBilling,
  terminateMeterBilling,
  updateMeterBilling,
  getMeterBillingDetails,
} from "../services/meterbilling.service";
import {
  getMeterBillingChargeCodes
} from "../services/list.service";
import {
  getBillingRefNumber,
  getVATAmount,
  isArray,
  isEmptyString,
  isNullUndefined,
  isValidDate,
  tryParseFloat,
  sortNumeric,
  formatCurrency,
} from "../util/util";
import Permit from "../util/permit";
import {issueResponseMessage, issueWarnMessage} from "../actions/message";
import { useSelector } from "react-redux";
import ReceivePayment from "../components/modals/receivePayment";
import ContractTermination from "../components/contractTermination";
import PersonOrgSearch from "../components/modals/personOrgSearch";
import AddNewUser from "../components/modals/addNewUser";
import AddNewOrganization from "../components/modals/addNewOrganization";
import {
  MainContainer,
  TopBarContainedBrandButton,
  TopBarContainer,
} from "../constants/component.constants";
import ExportDocumentsModal from "../components/modals/exportDocuments";
import CreditNote from "../components/modals/creditNote";
import DebitNote from "../components/modals/debitNote";
import {
  ResponsiveRow,
} from "../constants/layout.constants";
import AddMeterBilling from "../components/modals/utilities/meterBilling/addMeterBillingModal";
import AddMeterBillingNote from "../components/modals/utilities/meterBilling/addMeterNote";
import MeterBillingSuspendModal from "../components/modals/utilities/meterBilling/suspendModal";
import DownloadMeterBillingModal from "../components/modals/utilities/meterBilling/downloadMeterBillingModal";
import MeterSwapModal from "../components/modals/utilities/meterBilling/meterSwapModal";
import ViewMeterBilling from "../components/modules/meterBilling/viewMeterBilling";
import MuiDataGrid from "../components/modules/MuiDataGrid";
import dayjs from "dayjs";
import SplitButton from "../components/splitButton";
import ConfirmationModal from "../components/modals/confirmation";
import { amber, deepOrange, green, red } from "@mui/material/colors";

export default function MeterBilling() {
  const [PaymentModal, setPaymentModal] = useState(false);
  const [NoteModal, setNoteModal] = useState(false);
  const [SuspendModal, setSuspendModal] = useState(false);
  const [TerminateModal, setTerminateModal] = useState(false);
  const [CustomerModal, setCustomerModal] = useState(false);
  const [DownloadModal, setDownloadModal] = useState(false);
  const [DownloadEmailModal, setDownloadEmailModal] = useState(false);
  const [DeleteModal, setDeleteModal] = useState(false);
  const [ActivateModal, setActivateModal] = useState(false);
  const [AddOrganizationModal, setAddOrganizationModal] = useState(false);
  const [AddUserModal, setAddUserModal] = useState(false);
  const [AddDiv, setAddDiv] = useState(false);
  const [ViewDiv, setViewDiv] = useState(false);
  const [EditDiv, setEditDiv] = useState(false);
  const [loading, setLoading] = useState(true);
  const [includeMeterBillingDetail, setMeterBillingDetail] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchReference, setSearchReference] = useState("");
  const [customerSearch, setCustomerSearch] = useState("");
  const [totalMeterbillings, setTotalMeterbillings] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 50,
    page: 0,
  });
  const [selectedMeterbilling, setselectedMeterbilling] = useState({});
  const [facilityMeters, setFacilityMeters] = useState([]);
  const [statementYear, setStatementYear] = useState(dayjs(new Date()));
  const [note, setNote] = useState("");
  const [suspendReason, setSuspendReason] = useState("");
  const [idTypeSearch, setIdType] = useState("");
  const [idNoSearch, setIdNo] = useState("");
  const [companySearch, setCompanySearch] = useState("");
  const [billingItems, setBillingItems] = useState([]);
  const [billingItemsTotal, setBillingItemsTotal] = useState(0);
  const [billingItemsTableRows, setBillingItemsTableRows] = useState("");
  const [chargeCodes, setChargeCodes] = useState([]);
  const [meterBillingMeters, setMeterBillingMeters] = useState([]);
  const [items, setItems] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const [terminateItem, setTerminateItem] = useState(null);
  const [titleText, setTitleText] = useState("");
  const [severityText, setSeverityText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [positiveText, setPositiveText] = useState("");
  const [negativeText, setNegativeText] = useState("");
  const [voiditem, setVoiditem] = useState(null);
  const [creditModal, setCreditModal] = useState(false);
  const [chargeModal, setChargeModal] = useState(false);
  const [task, setTask] = useState("");
  const [selectedBillingPeriod, setSelectedBillingPeriod] = useState("");
  const [selectedBillingDay, setSelectedBillingDay] = useState("");
  const [selectedBillingDate, setSelectedBillingDate] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedFacilityId, setSelectedFacilityId] = useState(null);
  const [swapModal, setSwapModal] = useState(false);
  const [swapModalMode, setSwapModalMode] = useState("swap");
  const [selectedMeterForAction, setSelectedMeterForAction] = useState(null);
  const [selectedMeterNameForAction, setSelectedMeterNameForAction] = useState("");
  const [selectedNewMeterId, setSelectedNewMeterId] = useState(null);
  const [pendingMeterRemoves, setPendingMeterRemoves] = useState([]);
  const [pendingMeterAdditions, setPendingMeterAdditions] = useState([]);

  const handlePaymentClose = () => setPaymentModal(false);

  const fetchData = async (controller = null) => {
    setLoading(true);
    setRows([]);
    try {
      getTotalMeterBillings(searchReference, customerSearch, {
        signal: controller?.signal,
      }).then((totalResponse) => {
        if (totalResponse?.totalBillings !== undefined) {
          setTotalMeterbillings(totalResponse.totalBillings);
        }
      });

      const result = await getMeterBilling(
        searchReference,
        customerSearch,
        paginationModel.page,
        paginationModel.pageSize,
        { signal: controller?.signal },
      );
      setRows(result || []);
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCreditClose = () => {
    setLoading(true);
    setVoiditem(null);
    setCreditModal(false);
    setViewDiv(false);
    fetchData();
  };
  const handleChargeClose = () => {
    setLoading(true);
    setVoiditem(null);
    setChargeModal(false);
    setViewDiv(false);
    fetchData();
  };
  const handleBillingClose = () => {
    setselectedMeterbilling(null);
    setItems([]); //Clear items
    setBillingItems([]); //Clear items
    setBillingItemsTotal(0);
    setAddDiv(false);
    setEditDiv(false);
    setTask("");
    // Clear pending meter operations when closing
    setPendingMeterRemoves([]);
    setPendingMeterAdditions([]);
    // Clear billing form state
    setSelectedBillingPeriod("");
    setSelectedBillingDay("");
    setSelectedBillingDate("");
    setMeterBillingMeters([]);
  };
  const handleTerminateClose = () => {
    setItems([]); //Clear items
    setTerminateModal(false);
    setTerminateItem(null);
    setselectedMeterbilling(null);
  };
  const handleDownloadClose = () => {
    setRowSelectionModel([]); //Clear selection
    setStatementYear(dayjs(new Date()));
    setMeterBillingDetail(false);
    setDownloadModal(false);
    setTitleText("");
    setSeverityText("");
    setBodyText("");
  };

  useEffect(() => {
    getMeterBillingChargeCodes().then((chargeCodes) => setChargeCodes(chargeCodes));
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    if (user.proxyFacility != null) {
      if (selectedFacilityId == null) {
        setSelectedFacilityId(user.proxyFacility);
        getMetersByFacilityNotInActiveBilling(user.proxyFacility).then((facilityMeters) =>
            setFacilityMeters(facilityMeters),
        );
      } else {
        if (!selectedFacilityId.includes(user.proxyFacility)) {
          setSelectedFacilityId(user.proxyFacility);
          getMetersByFacilityNotInActiveBilling(user.proxyFacility).then((facilityMeters) =>
              setFacilityMeters(facilityMeters),
          );
        }
      }
    }

    const timer = setTimeout(() => {
      if(user.proxyFacility != null) {
        fetchData(controller);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [
    searchReference,
    customerSearch,
    paginationModel.page,
    paginationModel.pageSize,
    user.proxyFacility,
  ]);

  useEffect(() => {
    if (
        !isNullUndefined(selectedMeterbilling?.id)
    ) {
      getMetersByMeterBilling(selectedMeterbilling.id)
          .then((meterBillingMeters) => {
            setMeterBillingMeters(meterBillingMeters);
            // Filter meterIds to only include meters with active charges
            const activeMeterIds = meterBillingMeters.map((m) => m.value);
            if (
                selectedMeterbilling.meterIds &&
                selectedMeterbilling.meterIds.length > 0
            ) {
              const filteredMeterIds = selectedMeterbilling.meterIds.filter((id) =>
                  activeMeterIds.includes(id)
              );
              // Only update if there's a difference to avoid infinite loops
              if (
                  filteredMeterIds.length !== selectedMeterbilling.meterIds.length ||
                  filteredMeterIds.some(
                      (id, idx) => id !== selectedMeterbilling.meterIds[idx]
                  )
              ) {
                setselectedMeterbilling({
                  ...selectedMeterbilling,
                  meterIds: filteredMeterIds,
                });
              }
            }
          })
      setItems(selectedMeterbilling?.billingChargeItems || []); // Set items from billingChargeItems
    }
  }, [selectedMeterbilling?.id]); // Only depend on the ID to avoid loops

  useEffect(() => {
    populateMeterBillingItems();
  }, [billingItems, meterBillingMeters, selectedMeterbilling?.meterIds, items]);

  function onTextChange(searchText) {
    const id = searchText.target.id;
    const value = searchText.target.value;
    if (id === "searchCode") {
      setSearchReference(value);
    }
    if (id === "searchCustomer") {
      setCustomerSearch(value);
    }
    if (id === "note") {
      setNote(value);
    }
    if (id === "suspendReason") {
      setSuspendReason(value);
    }
  }

  function handleMeterBillingDateChange(value) {
    // let value = event.target.value
    let date = new Date(value);
    let obj = {...selectedMeterbilling};
    obj.effectiveDate = date;
    setselectedMeterbilling(obj);
  }

  function handleNextBillingDateChange(value) {
    let date = new Date(value);
    setSelectedBillingDate(date);
    let obj = {...selectedMeterbilling};
    obj.billingDate = date;
    setselectedMeterbilling(obj);
  }

  function validateMeterBillingForm() {
    let data = selectedMeterbilling;
    if (task !== 'Edit' && data.meterIds?.length < 1) {
      issueWarnMessage("You must select at least one meter");
      return false;
    }

    if (isNullUndefined(data)) {
      issueWarnMessage("Could not determine Meter Billing to save");
      return false;
    }
    let startDate = new Date(data.effectiveDate);
    if (!isValidDate(startDate)) {
      issueWarnMessage("Start date is not a valid date!!");
      return false;
    }
    if (isNullUndefined(data.customer.id)) {
      if (
          isNullUndefined(data.customer.name) ||
          isEmptyString(data.customer.name)
      ) {
        issueWarnMessage("A customer must be selected!!");
        return false;
      }
    }
    if (
        isNullUndefined(data.meterIds) ||
        !isArray(data.meterIds) ||
        data.meterIds.length < 1
    ) {
      issueWarnMessage("Meters must be selected!!");
      return false;
    }
    if (isEmptyString(data.billingPeriod)) {
      issueWarnMessage("Billing frequency must be selected!!");
      return false;
    }
    if (data.billingPeriod === "MNTH") {
      if (isEmptyString(data.billingDay)) {
        issueWarnMessage("Billing day must be selected!!");
        return false;
      }
    }
    if (data.billingPeriod === "ANU" || data.billingPeriod === "QT") {
      if (isEmptyString(data.billingDate)) {
        issueWarnMessage("Next billing date must be selected!!");
        return false;
      }
    }
    if (data.billingChargeItems.length < 1) {
      issueWarnMessage(
          "You must add at least one charge to save the meterbilling.",
      );
      return false;
    }
    if (isArray(data.billingChargeItems)) {
      for (let charge of data.billingChargeItems) {
        if (isEmptyString(charge.chargeCode)) {
          issueWarnMessage(
              "Could not determine the charge type for one of the charges.",
          );
          return false;
        }
        if (isNullUndefined(charge.amount)) {
          issueWarnMessage("A charge must have an amount.");
          return false;
        }
        let amount = tryParseFloat(charge.amount.toString(), -1);
        if (amount < 0) {
          let message =
              "Amount '" +
              charge.amount +
              "' for charge " +
              charge.chargeCode.name +
              " is invalid. Cannot be below 0";
          if (
              !isNullUndefined(charge.chargeCode) &&
              !isEmptyString(charge.chargeCode.name)
          ) {
            message =
                "Amount for charge " +
                charge.chargeCode.name +
                " cannot be below 0";
          }
          issueWarnMessage(message);
          return false;
        }
      }
    }
    setselectedMeterbilling(data);
    if (!validateLatePenalty(data.latePenalty)) {
      return false;
    }
    return true;
  }

  function savePayment(data) {
    data.meterBillingId = selectedMeterbilling.id;
    saveMeterBillingPayment(data)
        .then((response) => {
          issueResponseMessage(response);
          if (!isNullUndefined(response.meterBilling)) {
            handlePaymentClose();
            setLoading(true);
            fetchData();
          }
        })
        .catch((error) => {
          console.error("Error saving payment:", error);
          issueWarnMessage("Failed to save payment. Please try again.");
          setLoading(false);
        })
  }

  function saveMeterBilling() {
    selectedMeterbilling.billingChargeItems = items;
    setselectedMeterbilling(selectedMeterbilling);
    let data = {
      meterIds: selectedMeterbilling.meterIds || [],
      selectedBilling: selectedMeterbilling,
    };

    if (validateMeterBillingForm()) {
      setLoading(true);
      saveNewMeterBilling(data)
          .then((response) => {
            issueResponseMessage(response);
            // A rejected save resolves to undefined (the service raises the error
            // toast), e.g. when the customer's contact or credential validation
            // fails. Keep the modal open so the details can be corrected.
            if (isNullUndefined(response) || response.type === "error") {
              setLoading(false);
              return;
            }
            setAddDiv(false);
            handleBillingClose();
            // Refetch data and keep loading true until complete
            fetchData();
          })
          .catch((error) => {
            console.error("Error saving new billing:", error);
            issueWarnMessage("Failed to save new billing. Please try again.");
            setLoading(false);
          });
    }
  }

  function saveNote() {
    let data = {
      meterBillingId: selectedMeterbilling.id,
      note: note,
    };
    if (isEmptyString(data.note)) {
      issueWarnMessage("Cannot submit an empty note");
      return false;
    }
    saveMeterBillingNote(data).then((response) => {
      issueResponseMessage(response);
      setNoteModal(false);
      setNote("");
    });
  }

  function suspendBilling() {
    let data = {
      meterBillingId: selectedMeterbilling.id,
      statusChangeReason: suspendReason,
      currentStatus: selectedMeterbilling.status,
    };

    if (!data?.statusChangeReason || isEmptyString(data.statusChangeReason)) {
      issueWarnMessage("Cannot submit without a reason for suspension");
      return false;
    }
    suspendMeterBilling(data)
        .then((response) => {
          issueResponseMessage(response);
          // After successful suspend/reactivate, refresh available meters list
          // (suspending makes meters available, reactivating makes them unavailable)
          if (user.proxyFacility != null) {
            getMetersByFacilityNotInActiveBilling(user.proxyFacility).then((facilityMeters) =>
                setFacilityMeters(facilityMeters)
            );
          }
          if (!isNullUndefined(response.meterBilling)) {
            setSuspendModal(false);
            setSuspendReason(""); // Clear reason after successful suspend
            setLoading(true);
            fetchData();
          }
        })
        .catch((error) => {
          console.error("Error suspending billing:", error);
          issueWarnMessage("Failed to suspend billing. Please try again.");
          setLoading(false);
        })
  }

  function terminateBilling(data) {
    terminateMeterBilling(data)
        .then((response) => {
          issueResponseMessage(response);
          // After successful termination, refresh available meters list
          if (user.proxyFacility != null) {
            getMetersByFacilityNotInActiveBilling(user.proxyFacility).then((facilityMeters) =>
                setFacilityMeters(facilityMeters)
            );
          }
          handleTerminateClose();
          setAddDiv(false);
          setLoading(true);
          fetchData();
        })
        .catch((error) => {
          console.error("Error terminating billing:", error);
          issueWarnMessage("Failed to terminate billing. Please try again.");
          setLoading(false);
        })
  }

  function activateDraft() {
    if (isNullUndefined(selectedMeterbilling)) {
      issueWarnMessage(
          "Could not determine Meter Billing ID for activation. Try refresh the page or contact support.",
      );
      return;
    }
    setLoading(true);
    let data = {
      id: selectedMeterbilling.id,
    };

    activateMeterBilling(data)
        .then((response) => {
          issueResponseMessage(response);
          // After successful activation, refresh available meters list
          // (activating makes meters unavailable)
          if (user.proxyFacility != null) {
            getMetersByFacilityNotInActiveBilling(user.proxyFacility).then((facilityMeters) =>
                setFacilityMeters(facilityMeters)
            );
          }
          setActivateModal(false);
          setselectedMeterbilling(null);
          fetchData();
        })
        .catch((error) => {
          console.error("Error activating billing:", error);
          issueWarnMessage("Failed to activate billing. Please try again.");
          setLoading(false);
        })
  }

  function deleteDraft() {
    if (isNullUndefined(selectedMeterbilling)) {
      issueWarnMessage(
          "Could not determine Meter Billing ID for deletion. Try refresh the page or contact support.",
      );
      return;
    }

    let data = {meterBillingId: selectedMeterbilling.id}
    deleteDraftMeterBilling(data)
        .then((response) => {
          issueResponseMessage(response);
          setDeleteModal(false);
          setselectedMeterbilling(null);
          setLoading(true);
          fetchData();
        })
        .catch((error) => {
          console.error("Error deleting billing:", error);
          issueWarnMessage("Failed to delete billing. Please try again.");
          setLoading(false);
        })
  }

  function updateBilling() {
    selectedMeterbilling.billingChargeItems = items;
    // Use form state values to preserve user input even if selectedMeterbilling gets refreshed with nulls
    // This ensures billingDay/billingDate persist when adding meters (which returns nulls from server)
    let data = {
      id: selectedMeterbilling.id,
      billingPeriod: selectedBillingPeriod || selectedMeterbilling.billingPeriod,
      billingDay: isEmptyString(selectedBillingDay)
          ? null
          : (selectedBillingDay || selectedMeterbilling.billingDay || null),
      billingDate: selectedBillingDate || selectedMeterbilling.billingDate || null,
      billingChargeItems: selectedMeterbilling.billingChargeItems,
      latePenalty: selectedMeterbilling.latePenalty,
    };

    if (selectedMeterbilling?.statusCd === "DRF" && !selectedMeterbilling.hasTransactions) {
      const obj = selectedMeterbilling.customer
      if (obj.id) {
        if (obj.type === "Individual" && obj.id.split("_").length < 2) {
          obj.id = obj.id + "_P"
        } else if (obj.type === "Company" && obj.id.split("_").length < 2) {
          obj.id = obj.id + "_O"
        }
      }
      data.customer = obj
    }
    const handleSaveBilling = async () => {
      if (!validateMeterBillingForm()) return;

      try {
        setLoading(true);

        // 1. Process Removes
        const removePromises = pendingMeterRemoves.map(removeOp =>
            removeMeterFromBilling({
              meterBillingId: selectedMeterbilling.id,
              meterId: removeOp.meterId,
              finalMeterReading: removeOp.finalMeterReading,
              metersToAdd: `${pendingMeterAdditions.length}`
            })
        );
        const responses = await Promise.all(removePromises);
        if(responses.some(r => r.type.toLowerCase() === "error")) {
          setLoading(false);
          return
        }

        // 2. Process Additions (Only runs if Removals succeeded)
        const addPromises = pendingMeterAdditions.map(addOp =>
            addMeterToBilling({
              meterBillingId: selectedMeterbilling.id,
              newMeterId: addOp.meterId,
              initialMeterReading: addOp.initialMeterReading,
            })
        );
        await Promise.all(addPromises);

        // 3. Final Update
        const response = await updateMeterBilling(data);
        issueResponseMessage(response);

        // A rejected update resolves to undefined (the service raises the error
        // toast), e.g. when the customer's contact or credential validation
        // fails. Keep the modal open so the details can be corrected.
        if (isNullUndefined(response) || response.type === "error") {
          return;
        }

        // Success Cleanup
        setPendingMeterRemoves([]);
        setPendingMeterAdditions([]);
        handleBillingClose();

        if (response?.meterBilling) {
          await fetchData();
        }

      } catch (error) {
        console.error("Save process halted:", error);
      } finally {
        setLoading(false);
      }
    };
    return handleSaveBilling()
  }

  function handleViewClick(selectedMeterbilling) {
    getMeterBillingDetails(selectedMeterbilling.id).then((response) => {
      setselectedMeterbilling(response);
      setViewDiv(true);
    });
  }

  function handlePaymentClick(selectedMeterbilling) {
    setselectedMeterbilling(selectedMeterbilling);
    setPaymentModal(true);
  }

  function handleCreditClick(selectedMeterbilling) {
    setItems((prev) => [...prev, {accountId: null, amount: null}]);
    setselectedMeterbilling(selectedMeterbilling);
    setCreditModal(true);
  }

  function handleChargeClick(selectedMeterbilling) {
    setItems((items) => [
      ...items,
      {
        accountId: null,
        notes: null,
        amount: null,
        applyVAT: false,
        displayVATRadio: true,
      },
    ]);
    setselectedMeterbilling(selectedMeterbilling);
    setChargeModal(true);
  }

  function handleAddBillingClick() {
    let facilityId = null;
    const user = JSON.parse(localStorage.getItem("user"));
    if (user.proxyFacility != null) {
      facilityId = user.proxyFacility;
    }
    let data = {
      id: null,
      effectiveDate: "",
      customer: {
        id: null,
        firstName: null,
        name: null,
      },
      billingPeriod: "",
      billingDay: "",
      billingDate: "",
      billingCode: getBillingRefNumber(),
      billingChargeItems: [],
      facilityId: facilityId,
      meters: "",
      meterIds: [],
    };
    setselectedMeterbilling(data);
    // Clear all form states
    setSelectedBillingPeriod("");
    setSelectedBillingDay("");
    setSelectedBillingDate("");
    setItems([]);
    setBillingItems([]);
    setBillingItemsTotal(0);
    setMeterBillingMeters([]);
    setAddDiv(true);
    setEditDiv(false);
  }

  function handleEditClick(selectedMeterbilling) {
    // Get billing details and meter list in parallel
    Promise.all([
      getMeterBillingDetails(selectedMeterbilling.id),
      getMetersByMeterBilling(selectedMeterbilling.id),
    ])
        .then(([billingData, activeMeters]) => {
          // Filter meterIds to only include meters with active charges
          const activeMeterIds = activeMeters.map((m) => m.value);
          const filteredBillingData = {
            ...billingData,
            meterIds: billingData.meterIds
                ? billingData.meterIds.filter((id) => activeMeterIds.includes(id))
                : [],
            hasTransactions: selectedMeterbilling.hasTransactions,
            latePenalty: billingData.latePenalty,
          };
          setselectedMeterbilling(filteredBillingData);
          setMeterBillingMeters(activeMeters);
          // Sync billing period state
          if (filteredBillingData.billingPeriod) {
            setSelectedBillingPeriod(filteredBillingData.billingPeriod);
          } else {
            setSelectedBillingPeriod("");
          }
          // Sync billing day state - handle value 0 as valid
          if (filteredBillingData.billingDay !== undefined &&
              filteredBillingData.billingDay !== null &&
              filteredBillingData.billingDay !== "") {
            setSelectedBillingDay(String(filteredBillingData.billingDay));
          } else {
            setSelectedBillingDay("");
          }
          // Sync billing date state
          if (filteredBillingData.billingDate) {
            setSelectedBillingDate(filteredBillingData.billingDate);
          } else {
            setSelectedBillingDate("");
          }
        })
        .finally(() => {
          setAddDiv(false);
          setEditDiv(true);
          setTask("Edit");
        });
  }

  function handleMeterRemove(meterId, meterName) {
    setSelectedMeterForAction(meterId);
    setSelectedMeterNameForAction(meterName);
    setSwapModalMode("remove");
    setSwapModal(true);
  }

  function handleMeterAdd() {
    // Open modal to select a new meter to add
    // Charges will be added manually by the user after the meter is added
    setSelectedMeterForAction(null);
    setSelectedMeterNameForAction("");
    setSelectedNewMeterId(null);
    setSwapModalMode("add");
    setSwapModal(true);
  }

  function handleAddMeterConfirm(newMeterId, readingData) {
    if (!selectedMeterbilling || !selectedMeterbilling.id || !newMeterId) {
      issueWarnMessage("Could not determine meter or billing for adding meter");
      return;
    }

    // Find the new meter
    const newMeter = facilityMeters.find((m) => m.value === newMeterId);
    const newMeterName = newMeter ? newMeter.label : newMeterId;

    // Check if this meter is already queued for addition
    if (pendingMeterAdditions.some(add => add.meterId === newMeterId)) {
      issueWarnMessage("This meter is already queued to be added");
      return;
    }

    // Check if meter is already in the billing
    if (selectedMeterbilling.meterIds && selectedMeterbilling.meterIds.includes(newMeterId)) {
      issueWarnMessage("This meter is already in the billing");
      return;
    }

    // Queue the add operation instead of executing immediately
    const addOperation = {
      meterId: newMeterId,
      meterName: newMeterName,
      initialMeterReading: readingData?.initialMeterReading || null,
    };

    // Add to pending additions
    setPendingMeterAdditions((prev) => [...prev, addOperation]);

    // Immediately update the UI to reflect the pending addition
    const updatedMeterIds = [...(selectedMeterbilling.meterIds || []), newMeterId];
    const updatedMeterbilling = {
      ...selectedMeterbilling,
      meterIds: updatedMeterIds,
    };
    setselectedMeterbilling(updatedMeterbilling);

    // Update meter list to include the new meter
    if (newMeter) {
      setMeterBillingMeters((prev) => [...prev, newMeter]);
    }

    setSwapModal(false);
    setSelectedMeterForAction(null);
    setSelectedMeterNameForAction("");
    setSelectedNewMeterId(null);
  }

  function handleRemoveConfirm(readingData) {
    if (!selectedMeterForAction || !selectedMeterbilling.id) {
      issueWarnMessage("Could not determine meter or billing to remove");
      return;
    }

    if (!readingData || !readingData.finalMeterReading) {
      issueWarnMessage("Final meter reading is required to remove a meter");
      return;
    }

    // Queue the remove operation instead of executing immediately
    const removeOperation = {
      meterId: selectedMeterForAction,
      meterName: selectedMeterNameForAction,
      finalMeterReading: readingData.finalMeterReading,
    };

    // Add to pending removes
    setPendingMeterRemoves((prev) => [...prev, removeOperation]);

    // Update the meterIds in selectedMeterbilling to reflect the pending removal
    const updatedMeterIds = selectedMeterbilling.meterIds.filter(
        (id) => id !== selectedMeterForAction
    );
    const updatedMeterbilling = {
      ...selectedMeterbilling,
      meterIds: updatedMeterIds,
    };
    setselectedMeterbilling(updatedMeterbilling);

    // Update meter list to exclude the removed meter
    setMeterBillingMeters((prev) =>
        prev.filter((meter) => meter.value !== selectedMeterForAction)
    );

    // Remove items associated with this meter
    setItems((prevItems) =>
        prevItems.filter(
            (item) => item.meter && item.meter.id !== selectedMeterForAction
        )
    );

    setSwapModal(false);
    setSelectedMeterForAction(null);
    setSelectedMeterNameForAction("");
  }


  function handleNoteClick(selectedMeterbilling) {
    setselectedMeterbilling(selectedMeterbilling);
    setNoteModal(true);
  }

  function handleSuspendClick(selectedMeterbilling) {
    setselectedMeterbilling(selectedMeterbilling);
    setSuspendReason(""); // Clear previous reason when opening modal
    setSuspendModal(true);
  }

  function handleTerminateClick(selectedMeterbilling) {
    let data = {
      meterBillingId: selectedMeterbilling.id,
      paymentMethod: "", //CASH/CHEQUE - only needed if final balance < 0
      cashAccountId: "", //When Cash, must select which account
      chequeNumber: "", // When Cheque
      bankRefNumber: "", // For RTGS payments
      charges: [],
    };
    setTerminateItem(data);
    setItems([]);
    setselectedMeterbilling(selectedMeterbilling);
    setTerminateModal(true);
  }

  function handleActivateClick(selectedMeterbilling) {
    setselectedMeterbilling(selectedMeterbilling);
    setActivateModal(true);
  }

  function handleDeleteClick(selectedMeterbilling) {
    setselectedMeterbilling(selectedMeterbilling);
    setDeleteModal(true);
  }

  function handleBillingPeriodChange(event) {
    let value = event.target.value;
    setSelectedBillingPeriod(value);
    let obj = {...selectedMeterbilling};
    obj.billingPeriod = value;
    setselectedMeterbilling(obj);
  }

  function handleMetersChange(event, newValue) {
    // newValue is an array of selected meter objects from the autocomplete
    const newMeterIds = newValue.map((meter) => meter.value);
    const obj = {...selectedMeterbilling};
    obj.meterIds = newMeterIds;
    obj.meters = newValue.map((meter) => meter.label).join(", ");
    setselectedMeterbilling(obj);

    setItems((prevItems) =>
      prevItems.filter(
        (item) => !item.meter?.id || newMeterIds.includes(item.meter.id)
      )
    );
  }

  function handleBillingDayChange(event) {
    let value = event.target.value;
    setSelectedBillingDay(value);
    let obj = {...selectedMeterbilling};
    obj.billingDay = value;
    setselectedMeterbilling(obj);
  }

  function handleBillingAccountChange(event, index) {
    let value = event.target.value;
    let name = event.target.label;
    let newArr = [...items]; // copying the old items array
    newArr[index].chargeCode.code = value;
    newArr[index].chargeCode.name = name;
    setItems(newArr);
    populateMeterBillingItems();
  }

  function handleBillingMeterChange(event, index) {
    let value = event.target.value;
    let name = event.target.label;
    let newArr = [...items]; // copying the old items array
    newArr[index].meter.id = value;
    newArr[index].meter.name = name;
    setItems(newArr);
    populateMeterBillingItems();
  }

  function billingAmountChange(event, index) {
    const value = event.target.value;
    let newArr = [...items]; // copying the old items array
    newArr[index].amount = value;
    setItems(newArr);
    populateMeterBillingItems();
  }

  function handleStatementYearChange(value) {
    let date = dayjs(new Date(value));
    setStatementYear(date);
  }

  function handleBillingItemAdd() {
    setItems((items) => [
      ...items,
      {
        meter: {name: "", id: ""},
        chargeCode: {code: "", name: ""},
        amount: null,
        date: null,
        taxable: false,
      },
    ]);
    setBillingItems((billingItems) => [
      ...billingItems,
      {
        meter: null,
        chargeCode: null,
        setDownloadModal,
        amount: null,
        date: null,
        taxable: false,
      },
    ]);
  }

  function handleChargeItemRemove(index) {
    let newArr = [...items]; // copying the old items array
    if (newArr.length > 1) {
      findAndRemoveChargeVAT(items[index]);
      newArr.splice(index, 1);
      setItems(newArr);
    } else {
      issueWarnMessage("There must be at least one credit item");
    }
  }

  function handleBillingItemRemove(index) {
    let newArr = [...items]; // copying the old items array
    if (newArr.length > 1) {
      findAndRemoveBillingVAT(items[index]);
      newArr.splice(index, 1);
      setItems(newArr);
      setBillingItems(newArr);
    } else {
      issueWarnMessage("There must be at least one credit item");
    }
  }

  function isMeterFullyCharged(meterId, currentRowIndex) {
    if (!chargeCodes?.length || !meterId) return false;

    const applicableCodes = chargeCodes
      .filter((cc) => cc.value !== "UTSCH")
      .map((cc) => cc.value);

    if (applicableCodes.length === 0) return false;

    const appliedCodes = new Set(
      (items || [])
        .filter(
          (charge, idx) =>
            idx !== currentRowIndex &&
            charge.meter?.id === meterId &&
            charge.chargeCode?.code
        )
        .map((charge) => charge.chargeCode.code)
    );

    return applicableCodes.every((code) => appliedCodes.has(code));
  }

  function populateMeterBillingItems() {
    let rows = "";
    let total = 0;
    let today = new Date();
    items &&
    items.length > 0 &&
    (rows = items.map(function (billingItem, rowIndex) {
      let disabled =
          task === "Edit" &&
          billingItem.chargeCode &&
          !isEmptyString(billingItem.chargeCode) &&
          !isNullUndefined(billingItem.id);
      let amount = tryParseFloat(billingItem.amount, -1);
      if (amount > 0) {
        total = total + amount;
      }
      return (
          <TableRow key={rowIndex}>
            {(EditDiv || AddDiv) && (
                <TableCell>
                  <Select
                      sx={{width: "90%"}}
                      id={"meter"}
                      disabled={false}
                      value={items && items[rowIndex] && items[rowIndex].meter.id}
                      onChange={(event) => handleBillingMeterChange(event, rowIndex)}
                      defaultValue={[""]}
                  >
                    {(() => {
                      // In add mode, filter facilityMeters to only show selected meters
                      // In edit mode, use meterBillingMeters
                      let availableMeters = AddDiv ? facilityMeters : meterBillingMeters;
                      if (AddDiv && selectedMeterbilling && selectedMeterbilling.meterIds) {
                        if (selectedMeterbilling.meterIds.length > 0) {
                          availableMeters = facilityMeters.filter(meter =>
                              selectedMeterbilling.meterIds.includes(meter.value)
                          );
                        } else {
                          // If no meters selected yet, show empty list
                          availableMeters = [];
                        }
                      }
                      return availableMeters && availableMeters.length > 0 ? (
                          availableMeters.map(function (meterOption) {
                            const meterDisabled = isMeterFullyCharged(
                              meterOption.value,
                              rowIndex
                            );
                            return (
                                <MenuItem
                                    key={meterOption.value}
                                    value={meterOption.value}
                                    disabled={meterDisabled}
                                >
                                  {meterOption.label}
                                </MenuItem>
                            );
                          }, this)
                      ) : (
                          <MenuItem sx={{width: "100%"}}>No Results Found</MenuItem>
                      );
                    })()}
                  </Select>
                </TableCell>
            )}
            <TableCell>
              <Select
                  sx={{width: "90%"}}
                  id={"billingAccount" + rowIndex}
                  name={"billingAccount" + rowIndex}
                  isrequired={true}
                  disabled={disabled}
                  value={items && items[rowIndex].chargeCode && items[rowIndex].chargeCode.code}
                  onChange={(event) => handleBillingAccountChange(event, rowIndex)}
              >
                {chargeCodes && chargeCodes.length > 0 ? (
                    chargeCodes
                        .filter(function (chargeCode) {
                          // Hide "Utility - Standing Charge" for new charges
                          // Show it only if the current item already has it selected
                          if (chargeCode.value === "UTSCH") {
                            return billingItem.chargeCode && billingItem.chargeCode.code === "UTSCH";
                          }
                          return true;
                        })
                        .map(function (chargeCode, i) {
                          let disabled = false;
                          for (let chargeValue of items) {
                            if (
                                billingItem.meter &&
                                billingItem.meter.id === chargeValue.meter.id &&
                                chargeValue.chargeCode.code === chargeCode.value
                            ) {
                              disabled = true;
                            }
                          }
                          return (
                              <MenuItem
                                  key={chargeCode.value}
                                  disabled={disabled}
                                  value={chargeCode.value}
                              >
                                {chargeCode.label}
                              </MenuItem>
                          );
                        }, this)
                ) : (
                    <MenuItem sx={{width: "100%"}}>No Results Found</MenuItem>
                )}
              </Select>
            </TableCell>
            <TableCell>
              <TextField
                  sx={{width: "90%"}}
                  id={"billingItemAmount" + rowIndex}
                  name={"billingItemAmount" + rowIndex}
                  isrequired={true}
                  // disabled={items && items[rowIndex] && !items[rowIndex].displayVATRadio}
                  value={items && items[rowIndex] && items[rowIndex].amount}
                  onChange={(event) => billingAmountChange(event, rowIndex)}
              />
            </TableCell>
            <TableCell>
              <TextField
                  id={"date" + rowIndex}
                  disabled
                  placeholder={today.toString()}
                  value={items && items[rowIndex] && items[rowIndex].effectiveDate}
              />
            </TableCell>
            <TableCell>
              {billingItem &&
                  billingItem.chargeCode &&
                  billingItem.chargeCode.code &&
                  billingItem.chargeCode.code === "UTSCH" && (
                      <Checkbox
                          checked={items && items[rowIndex] && items[rowIndex].taxable}
                          onChange={(event) => handleBillingCheckboxToggle(event, rowIndex)}
                          inputProps={{"aria-label": "controlled"}}
                      />
                  )}
            </TableCell>
            <TableCell>
              <Button
                  variant="contained"
                  type="submit"
                  sx={{marginLeft: "10px"}}
                  onClick={(event) => handleBillingItemRemove(rowIndex)}
                  color="error"
              >
                <Cancel/>
              </Button>
            </TableCell>
          </TableRow>
      );
    }, this));
    setBillingItemsTableRows(rows);
    setBillingItemsTotal(total);
  }

  function findAndRemoveChargeVAT(detailItem) {
    let vatAmount = getVATAmount(detailItem.amount);
    for (let i = 0; i < items.length; i++) {
      if (
          items[i].amount === vatAmount &&
          items[i].notes.includes(detailItem.notes)
      ) {
        handleChargeItemRemove(i);
      }
    }
  }

  function findAndRemoveBillingVAT(detailItem) {
    let vatAmount = getVATAmount(detailItem.amount);
    for (let i = 0; i < items.length; i++) {
      if (items[i].amount === vatAmount) {
        handleBillingItemRemove(i);
      }
    }
    populateMeterBillingItems();
  }

  function handleBillingCheckboxToggle(event, index) {
    const value = event.target.checked;
    let newArr = [...items]; // copying the old items array
    newArr[index].taxable = value;
    setItems(newArr);
    populateMeterBillingItems();
  }

  function handleIncludeMeterBillingDetailToggle(event) {
    setMeterBillingDetail(event.target.checked);
  }

  const handlePersonOrgClose = () => {
    setCustomerModal(false);
  };

  function handlePersonOrgSelect(result) {
    let obj = {...selectedMeterbilling};
    obj.customer = result;
    setselectedMeterbilling(obj);
    setCustomerModal(false);
  }

  function showAddNewUserForm(idNoSearch, idTypeSearch) {
    setIdType(idTypeSearch);
    setIdNo(idNoSearch);
    setCustomerModal(false);
    setAddUserModal(true);
  }

  function showAddNewOrgForm(companySearch) {
    setCompanySearch(companySearch);
    setCustomerModal(false);
    setAddOrganizationModal(true);
  }

  function handleAddUserClose() {
    setAddUserModal(false);
  }

  function handleAddOrgClose() {
    setAddOrganizationModal(false);
  }

  function exportMeterbillingAccounts() {
    exportMeterBillings();
  }

  function handleDownloadClick() {
    setDownloadModal(true);
    let title =
        rowSelectionModel.length > 1
            ? "Download " + rowSelectionModel.length + " Meter Billings"
            : "Download Meter Billing";
    let body =
        "Note: Processing the selected meter billings may take some time." +
        " Therefore, the exported data will be emailed to you when it is finished being packaged." +
        " Please ensure the email set for your account is valid, working and that you have access to it in order to receive the export data.";
    setTitleText(title);
    setSeverityText("info");
    setBodyText(body);
  }

  function positiveExportDocsAction() {
    downloadMeterBillingDocs();
  }

  function downloadMeterBillingDocs() {
    if (isNullUndefined(rowSelectionModel) || rowSelectionModel.length < 1) {
      issueWarnMessage(
          "Could not determine the download items. Please refresh the page and try again.",
      );
      return;
    }
    let data = {
      meterBillingIds: rowSelectionModel,
      includeMeterBillingDetails: includeMeterBillingDetail,
      statementYear: dayjs(statementYear).year(), // e.g. 2022
    };
    downloadMeterBillings(data).then((response) => {
      issueResponseMessage(response);
      handleDownloadClose();
    });
  }

  function handleSendMeterBillingDocClick(docType) {
    let title = "Confirm Send " + docType;
    let body =
        "Are you sure you want to resend the last " +
        docType +
        " for " +
        rowSelectionModel.length +
        " selected meter billing(s)?";
    setTitleText(title);
    setTask("Resend " + docType);
    setSeverityText("warning");
    setBodyText(body);
    setPositiveText("Send");
    setNegativeText("Cancel");
    setShowConfirmationModal(true);
  }

  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
    setTitleText("");
    setTask("");
    setSeverityText("");
    setBodyText("");
    setPositiveText("");
    setNegativeText("");
    setselectedMeterbilling(null);
    setRowSelectionModel([]);
  };

  function resendLastMeterBillingInvoiceClicked() {
    let sendData = {bulkEditIds: rowSelectionModel};
    resendLastMeterBillingInvoice(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
    });
  }

  function resendLastMeterBillingReceiptClicked() {
    let sendData = {bulkEditIds: rowSelectionModel};
    resendLastMeterBillingReceipt(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
    });
  }

  function resendMeterBillingStatementClicked() {
    let sendData = {bulkEditIds: rowSelectionModel};
    resendMeterBillingStatement(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
    });
  }

  function positiveAction() {
    if (task === "Resend Invoice") {
      resendLastMeterBillingInvoiceClicked();
    } else if (task === "Resend Receipt") {
      resendLastMeterBillingReceiptClicked();
    } else if (task === "Resend Statement") {
      resendMeterBillingStatementClicked();
    }
  }

  function handleVoidClick(item) {
    if (item.type === "Charge" || item.type === "Invoice") {
      setCreditModal(true);
      //set the id of the transaction being voided
      setVoiditem(item);
    } else if (item.type === "Receipt" || item.type === "Credit") {
      setChargeModal(true);
      setVoiditem(item);
    }
  }

  const meterBillingButtons = [
    {
      label: "METER BILLING ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: () => handleDownloadClick(),
      label:
          rowSelectionModel.length > 1
              ? "Download " + rowSelectionModel.length + " Meter Billings"
              : "Download Meter Billing",
      roles: "BLDIR,ACC,SYSAD,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
    {
      action: () => handleSendMeterBillingDocClick("Invoice"),
      label:
          rowSelectionModel.length > 1
              ? "Resend " + rowSelectionModel.length + " Invoices"
              : "Resend Last Invoice",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
    {
      action: () => handleSendMeterBillingDocClick("Receipt"),
      label:
          rowSelectionModel.length > 1
              ? "Resend " + rowSelectionModel.length + " Receipt"
              : "Resend Last Receipt",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
    {
      action: () => handleSendMeterBillingDocClick("Statement"),
      label:
          rowSelectionModel.length > 1
              ? "Resend " + rowSelectionModel.length + " Statements"
              : "Resend Statement",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
  ];

  function getChipProps(params) {
    if (!isNullUndefined(params.value)) {
      if (params.value === "DRF") {
        return {
          icon: <Commit style={{fill: deepOrange[500]}}/>,
          label: "Draft",
          style: {
            borderColor: deepOrange[500],
          },
        };
      } else if (params.value === "ACT") {
        return {
          icon: <Check style={{fill: green[500]}}/>,
          label: "Active",
          style: {
            borderColor: green[500],
          },
        };
      } else if (params.value === "SUP") {
        return {
          icon: <Pause style={{fill: amber[500]}}/>,
          label: "Suspended",
          style: {
            borderColor: amber[500],
          },
        };
      } else if (params.value === "TER") {
        return {
          icon: <Clear style={{fill: red[500]}}/>,
          label: "Terminated",
          style: {
            borderColor: red[500],
          },
        };
      } else {
        return "N/A";
      }
    }
  }

  const columns = useMemo(() => [
    {
      headerName: "Billing Code",
      field: "billingCode",
      minWidth: 120,
      flex: 1.2,
    },
    {headerName: "Meter(s)", field: "meterNames", minWidth: 300, flex: 2},
    {
      headerName: "Billing Frequency",
      field: "billingFrequency",
      minWidth: 170,
      flex: 1.7,
      valueFormatter: (row) => {
        if (row.value === "MNTH") {
          return "Monthly";
        } else if (row.value === "ANU") {
          return "Annually";
        } else if (row.value === "QT") {
          return "Quarterly";
        } else return "N/A";
      },
    },
    {
      headerName: "Account Holder",
      field: "customer",
      minWidth: 370,
      flex: 3.7,
    },
    {
      headerName: "Balance",
      field: "balance",
      minWidth: 150,
      flex: 1.5,
      sortComparator: sortNumeric,
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
    {
      headerName: "Status",
      field: "status",
      minWidth: 140,
      flex: 1.2,
      renderCell: (params) => {
        return (
            <Chip variant="outlined" size="small" {...getChipProps(params)} />
        );
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      width: 100,
      type: "actions",
      getActions: (params) => {
        let arr = [];
        if (
            user.proxyRole === "REC" ||
            user.proxyRole === "BLDIR" ||
            user.proxyRole === "BLDMG" ||
            user.proxyRole === "CS"
        ) {
          arr.push(
              <GridActionsCellItem
                  icon={<Visibility/>}
                  label="View"
                  onClick={() => handleViewClick(params.row)}
                  showInMenu
              />,
          );
          arr.push(
              <GridActionsCellItem
                  icon={<LocalAtm/>}
                  label="Receive Payment"
                  onClick={() => handlePaymentClick(params.row)}
                  showInMenu
              />,
          );
        }
        if (params.row.status === "ACT") {
          if (
              user.proxyRole === "BLDIR" ||
              user.proxyRole === "BLDMG" ||
              user.proxyRole === "CS"
          ) {
            arr.push(
                <GridActionsCellItem
                    icon={<CreditCard/>}
                    label="Issue Credit"
                    onClick={() => handleCreditClick(params.row)}
                    showInMenu
                />,
            );
            arr.push(
                <GridActionsCellItem
                    icon={<NearMe/>}
                    label="Issue Charge"
                    onClick={() => handleChargeClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (user.proxyRole === "BLDIR") {
            arr.push(
                <GridActionsCellItem
                    icon={<Edit/>}
                    label="Edit"
                    onClick={() => handleEditClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (
              user.proxyRole === "REC" ||
              user.proxyRole === "BLDIR" ||
              user.proxyRole === "BLDMG" ||
              user.proxyRole === "CS"
          ) {
            arr.push(
                <GridActionsCellItem
                    icon={<Add/>}
                    label="Add Note"
                    onClick={() => handleNoteClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (user.proxyRole === "BLDIR" || user.proxyRole === "SYSAD") {
            arr.push(
                <GridActionsCellItem
                    icon={<Pause/>}
                    label="Suspend"
                    onClick={() => handleSuspendClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (
              user.proxyRole === "BLDIR" ||
              user.proxyRole === "BLDMG" ||
              user.proxyRole === "CS" ||
              user.proxyRole === "ACC"
          ) {
            arr.push(
                <GridActionsCellItem
                    icon={<Clear/>}
                    label="Terminate"
                    onClick={() => handleTerminateClick(params.row)}
                    showInMenu
                />,
            );
          }
        }
        if (params.row.status === "DRF") {
          if (
              user.proxyRole === "BLDIR" ||
              user.proxyRole === "BLDMG" ||
              user.proxyRole === "CS" ||
              user.proxyRole === "ACC"
          ) {
            arr.push(
                <GridActionsCellItem
                    icon={<Done/>}
                    label="Activate"
                    onClick={() => handleActivateClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (user.proxyRole === "BLDIR") {
            arr.push(
                <GridActionsCellItem
                    icon={<Edit/>}
                    label="Edit"
                    onClick={() => handleEditClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (params.row.hasTransactions) {
            if (
                user.proxyRole === "BLDIR" ||
                user.proxyRole === "BLDMG" ||
                user.proxyRole === "CS" ||
                user.proxyRole === "ACC"
            ) {
              arr.push(
                  <GridActionsCellItem
                      icon={<Clear/>}
                      label="Terminate"
                      onClick={() => handleTerminateClick(params.row)}
                      showInMenu
                  />,
              );
            }
          } else {
            if (
                user.proxyRole === "REC" ||
                user.proxyRole === "BLDIR" ||
                user.proxyRole === "BLDMG" ||
                user.proxyRole === "CS"
            ) {
              arr.push(
                  <GridActionsCellItem
                      icon={<Clear/>}
                      label="Delete"
                      onClick={() => handleDeleteClick(params.row)}
                      showInMenu
                  />,
              );
            }
          }
        }
        if (params.row.status === "SUP") {
          if (
              user.proxyRole === "BLDIR" ||
              user.proxyRole === "BLDMG" ||
              user.proxyRole === "CS" ||
              user.proxyRole === "ACC"
          ) {
            arr.push(
                <GridActionsCellItem
                    icon={<CreditCard/>}
                    label="Issue Credit"
                    onClick={() => handleCreditClick(params.row)}
                    showInMenu
                />,
            );
            arr.push(
                <GridActionsCellItem
                    icon={<NearMe/>}
                    label="Issue Charge"
                    onClick={() => handleChargeClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (user.proxyRole === "BLDIR" || user.proxyRole === "SYSAD") {
            arr.push(
                <GridActionsCellItem
                    icon={<PlayArrow/>}
                    label="Reactivate"
                    onClick={() => handleActivateClick(params.row)}
                    showInMenu
                />,
            );
          }
          if (
              user.proxyRole === "REC" ||
              user.proxyRole === "BLDIR" ||
              user.proxyRole === "BLDMG" ||
              user.proxyRole === "CS"
          ) {
            arr.push(
                <GridActionsCellItem
                    icon={<Add/>}
                    label="Add Note"
                    onClick={() => handleNoteClick(params.row)}
                    showInMenu
                />,
            );
          }
        }
        return arr;
      },
    },
  ]);

  return (
      <Permit
          roles="BLDIR,BLDMG,REC,CS"
          noPermittedServiceMessage={{
            title: "Access Denied",
            body: (
                <>
                  Your current role is not permitted to view this page. <br/> Please
                  contact your system admin if you feel this is an error.
                </>
            ),
          }}
      >
        <MainContainer>
          {!ViewDiv && (
              <TopBarContainer
                  container
                  sx={{
                    width: "100%",

                    // borderRadius: "10px",
                    boxShadow: "4px 4px 12px #aaa",
                  }}
              >
                <ResponsiveRow
                    item
                    sx={{
                      flexWrap: "nowrap",
                      justifyContent: "flex-start",
                      width: {xs: "100%", lg: "30%"},
                      padding: 0,
                      textAlign: "start",
                    }}
                >
                  <TextField
                      id="searchCode"
                      label="Search billing code"
                      sx={{
                        width: {xs: "100%", md: "90%"},
                        margin: "5px",
                      }}
                      onChange={(searchText) => onTextChange(searchText)}
                  />
                  <TextField
                      id="searchCustomer"
                      label="Search Customer"
                      sx={{
                        width: {xs: "100%", md: "90%"},
                        margin: "5px",
                      }}
                      onChange={(searchText) => onTextChange(searchText)}
                  />
                </ResponsiveRow>
                <ResponsiveRow
                    item
                    sx={{
                      flexWrap: "nowrap",
                      justifyContent: "flex-end",
                      width: {xs: "100%", lg: "70%"},
                      padding: 0,
                    }}
                >
                  <TopBarContainedBrandButton
                      onClick={handleAddBillingClick}
                      sx={{
                        width: {xs: "100%", md: "200px"},
                      }}
                  >
                    Add
                  </TopBarContainedBrandButton>

                  <Permit roles="BLDIR,ACC,SYSAD">
                    <TopBarContainedBrandButton
                        variant="contained"
                        onClick={exportMeterbillingAccounts}
                        sx={{
                          width: {xs: "100%", md: "200px"},
                          padding: "7px",
                        }}
                    >
                      Export Meter Billings
                    </TopBarContainedBrandButton>
                  </Permit>

                  <SplitButton buttons={meterBillingButtons}/>
                </ResponsiveRow>
              </TopBarContainer>
          )}

          <br/>

          {(AddDiv || EditDiv) && (
              <AddMeterBilling
                  AddDiv={AddDiv}
                  EditDiv={EditDiv}
                  handleBillingClose={handleBillingClose}
                  handleBillingDayChange={handleBillingDayChange}
                  handleBillingItemAdd={handleBillingItemAdd}
                  handleBillingPeriodChange={handleBillingPeriodChange}
                  handleMeterBillingDateChange={handleMeterBillingDateChange}
                  handleMetersChange={handleMetersChange}
                  handleNextBillingDateChange={handleNextBillingDateChange}
                  setCustomerModal={setCustomerModal}
                  updateBilling={updateBilling}
                  billingItemsTableRows={billingItemsTableRows}
                  billingItemsTotal={billingItemsTotal}
                  facilityMeters={facilityMeters}
                  meterBillingMeters={meterBillingMeters}
                  saveMeterBilling={saveMeterBilling}
                  selectedMeterbilling={selectedMeterbilling}
                  setSelectedMeterbilling={setselectedMeterbilling}
                  selectedBillingPeriod={selectedBillingPeriod}
                  selectedBillingDate={selectedBillingDate}
                  selectedBillingDay={selectedBillingDay}
                  onMeterRemove={handleMeterRemove}
                  onMeterAdd={handleMeterAdd}
                  pendingMeterRemoves={pendingMeterRemoves}
                  pendingMeterAdditions={pendingMeterAdditions}
              />
          )}

          {ViewDiv && (
              <ViewMeterBilling
                  selectedMeterBilling={selectedMeterbilling}
                  handleClose={() => setViewDiv(false)}
                  voiditem={voiditem}
                  handleVoidClick={handleVoidClick}
              />
          )}

          {/*ADD NEW USER MODAL*/}
          {AddUserModal && (
              <AddNewUser
                  openModal={AddUserModal}
                  closeModal={handleAddUserClose}
                  searchedIdType={idTypeSearch}
                  searchedIdNo={idNoSearch}
                  saveUser={handlePersonOrgSelect}
                  manageUsers={false}
              />
          )}

          {/*ADD NEW ORGANISATION MODAL*/}
          {AddOrganizationModal && (
              <AddNewOrganization
                  openModal={AddOrganizationModal}
                  searchedName={companySearch}
                  handleSave={true}
                  saveOrg={handlePersonOrgSelect}
                  closeModal={handleAddOrgClose}
              />
          )}

          {!ViewDiv && (
              <MuiDataGrid
                  dataGridColumns={columns}
                  dataGridRows={rows}
                  serverPagination={true}
                  handlePageLoad={setPaginationModel}
                  currentSelectionModel={rowSelectionModel}
                  handleSelectedRows={setRowSelectionModel}
                  loading={loading}
                  height="60vh"
                  totalRows={totalMeterbillings}
              />
          )}
          {/*PERSON/ORG SEARCH MODAL*/}
          {CustomerModal && (
              <PersonOrgSearch
                  contractType={"meterBilling"}
                  showPersonOrgModal={CustomerModal}
                  handlePersonOrgClose={handlePersonOrgClose}
                  handlePersonOrgSelect={handlePersonOrgSelect}
                  showAddNewUserForm={showAddNewUserForm}
                  showAddNewOrgForm={showAddNewOrgForm}
              />
          )}

          {/*RECEIVE PAYMENT MODAL*/}
          {PaymentModal && (
              <ReceivePayment
                  showPaymentModal={PaymentModal}
                  handlePaymentClose={handlePaymentClose}
                  paymentMode={"Meter Billing"}
                  contract={selectedMeterbilling}
                  savePayment={savePayment}
              />
          )}

          {/*CREATE CREDIT MODAL*/}
          {creditModal && (
              <CreditNote
                  open={creditModal}
                  onClose={handleCreditClose}
                  voiditem={voiditem}
                  meterbillingid={selectedMeterbilling && selectedMeterbilling.id}
              />
          )}

          {/*CREATE CHARGE MODAL*/}
          {chargeModal && (
              <DebitNote
                  open={chargeModal}
                  onClose={handleChargeClose}
                  voiditem={voiditem}
                  meterbillingid={selectedMeterbilling && selectedMeterbilling.id}
              />
          )}

          {/*ADD NOTE MODAL*/}
          <AddMeterBillingNote
              NoteModal={NoteModal}
              onTextChange={onTextChange}
              setNoteModal={setNoteModal}
              setNote={setNote}
              note={note}
              saveNote={saveNote}
              selectedMeterbilling={selectedMeterbilling}
          />

          {/*SUSPEND MODAL*/}
          <MeterBillingSuspendModal
              SuspendModal={SuspendModal}
              setSuspendModal={(open) => {
                setSuspendModal(open);
                if (!open) {
                  setSuspendReason(""); // Clear reason when modal is closed
                }
              }}
              onTextChange={onTextChange}
              selectedMeterbilling={selectedMeterbilling}
              suspendBilling={suspendBilling}
              suspendReason={suspendReason}
          />

          {/*TERMINATE MODAL*/}
          {TerminateModal && (
              <ContractTermination
                  showTerminateModal={TerminateModal}
                  handleTerminateClose={handleTerminateClose}
                  terminationMode={"Meter Billing"}
                  terminateItem={terminateItem}
                  contract={selectedMeterbilling}
                  terminateContract={terminateBilling}
              />
          )}

          {/*DOWNLOAD MODAL*/}
          <DownloadMeterBillingModal
              DownloadModal={DownloadModal}
              handleDownloadClose={handleDownloadClose}
              handleIncludeMeterBillingDetailToggle={
                handleIncludeMeterBillingDetailToggle
              }
              handleStatementYearChange={handleStatementYearChange}
              setDownloadEmailModal={setDownloadEmailModal}
              downloadMeterBillingDocs={downloadMeterBillingDocs}
              includeMeterBillingDetail={includeMeterBillingDetail}
              selectionModel={rowSelectionModel}
              statementYear={statementYear}
          />

          {/*METER SWAP/REMOVE MODAL*/}
          {swapModal && (
              <MeterSwapModal
                  swapModal={swapModal}
                  setSwapModal={setSwapModal}
                  mode={swapModalMode}
                  selectedMeterId={selectedMeterForAction}
                  selectedMeterName={selectedMeterNameForAction}
                  selectedNewMeterId={selectedNewMeterId}
                  setSelectedNewMeterId={setSelectedNewMeterId}
                  availableMeters={
                    swapModalMode === "add" && selectedMeterbilling && selectedMeterbilling.meterIds
                        ? facilityMeters.filter(
                            (meter) =>
                                !selectedMeterbilling.meterIds.includes(meter.value)
                        )
                        : []
                  }
                  onRemoveConfirm={handleRemoveConfirm}
                  onAddConfirm={handleAddMeterConfirm}
              />
          )}

          {/*Download/Export Document via Email... Shared Modal*/}
          {DownloadEmailModal && (
              <ExportDocumentsModal
                  showExportDocumentsModal={DownloadEmailModal}
                  handleExportDocumentsClose={handleDownloadClose}
                  title={titleText}
                  severity={severityText}
                  body={bodyText}
                  contract={"Meter Billing"}
                  handleIncludeDetailToggle={handleIncludeMeterBillingDetailToggle}
                  handleStatementYearChange={handleStatementYearChange}
                  includeDetails={includeMeterBillingDetail}
                  statementYear={statementYear}
                  handleExportDocuments={positiveExportDocsAction}
                  handleCancel={() => {
                    setDownloadEmailModal(false);
                  }}
              />
          )}

          {/*CONFIRMATION MODAL*/}
          {showConfirmationModal && (
              <ConfirmationModal
                  showConfirmationModal={showConfirmationModal}
                  handleConfirmationClose={handleConfirmationClose}
                  title={titleText}
                  severity={severityText}
                  body={bodyText}
                  positiveText={positiveText}
                  negativeText={negativeText}
                  positiveAction={positiveAction}
                  negativeAction={handleConfirmationClose}
              />
          )}

          {(ActivateModal || DeleteModal) && (
              <ConfirmationModal
                  showConfirmationModal={(ActivateModal || DeleteModal)}
                  handleConfirmationClose={ActivateModal ? () => {
                    setActivateModal(false);
                    setselectedMeterbilling(null);
                  } : () => setDeleteModal(false)}
                  title={ActivateModal ? "Activate Billing?" : "Confirm Delete Billing?"}
                  severity={ActivateModal ? "info" : "error"}
                  body={
                    ActivateModal ?
                        "Are you sure you wish to Activate this Billing?" :
                        "Are you sure you want to permanently delete this Meter Billing along with any other associated data such as charges, contacts, and documents?"
                  }
                  positiveText={ActivateModal ? "Yes, Activate" : "Delete Billing"}
                  negativeText={"Cancel"}
                  positiveAction={ActivateModal ? activateDraft : deleteDraft}
                  acceptLoading={loading}
                  negativeAction={ActivateModal ? () => {
                    setActivateModal(false);
                    setselectedMeterbilling(null);
                  } : () => setDeleteModal(false)}
              />
          )}
        </MainContainer>
      </Permit>
  );
}
